import React from 'react';

// Import your actual logo files
import logoFull from '../../assets/requestasong-logo.png';
import logoSymbol from '../../assets/requestasong-symbol.png';

// RequestASong Logo Component using your actual PNG files
export const RequestASongLogo = ({ size = 100, showText = true, symbolOnly = false }) => {
  // If symbolOnly is true, always show just the symbol regardless of showText
  const useSymbolOnly = symbolOnly || !showText;
  
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center'
    }}>
      {useSymbolOnly ? (
        // Just the star symbol
        <img 
          src={logoSymbol}
          alt="RequestASong"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            objectFit: 'contain'
          }}
        />
      ) : (
        // Full logo with text
        <img 
          src={logoFull}
          alt="RequestASong"
          style={{
            height: `${size}px`,
            width: 'auto', // Let width scale proportionally
            objectFit: 'contain'
          }}
        />
      )}
    </div>
  );
};